<template>
  <SkeletonLoader>
    <div class="prod-trends-skeleton">
      <!-- Filter Row: Date Range + Provider + Toggle -->
      <div class="sk-filter-row">
        <div class="sk-filter-col" style="width: 40%">
          <div class="sk-line sk-line--sm" style="width: 80px"></div>
          <div class="sk-rect" style="width: 100%; height: 38px"></div>
        </div>
        <div class="sk-filter-col" style="width: 30%">
          <div class="sk-line sk-line--sm" style="width: 70px"></div>
          <div class="sk-rect" style="width: 100%; height: 38px"></div>
        </div>
        <div class="sk-filter-col" style="width: 20%">
          <div class="sk-line sk-line--sm" style="width: 60px"></div>
          <div class="sk-rect" style="width: 100%; height: 38px"></div>
        </div>
      </div>

      <!-- Timeframe Pill Buttons -->
      <div class="sk-pills-row">
        <div v-for="pill in timeframePills" :key="pill.id"
          class="sk-rect" :style="{ width: pill.width, height: '30px' }">
        </div>
      </div>

      <!-- Chart Placeholder -->
      <div class="sk-chart-area">
        <div class="sk-rect" style="width: 100%; height: 250px"></div>
      </div>

      <!-- Table -->
      <div class="sk-table-card">
        <!-- Table Header -->
        <div class="sk-row sk-table-header">
          <div v-for="col in headerColumns" :key="col.id" class="sk-col">
            <div class="sk-line sk-line--sm" :style="{ width: col.width }"></div>
          </div>
        </div>
        <!-- Table Rows -->
        <div v-for="row in tableRows" :key="row.id" class="sk-row sk-table-row">
          <div class="sk-col sk-col--name">
            <div class="sk-circle sk-circle--sm"></div>
            <div class="sk-line" :style="{ width: row.nameWidth }"></div>
          </div>
          <div v-for="(val, idx) in row.values" :key="idx" class="sk-col hide-mobile">
            <div class="sk-line" :style="{ width: val }"></div>
          </div>
        </div>
      </div>
    </div>
  </SkeletonLoader>
</template>

<script>
import SkeletonLoader from '@/components/SkeletonLoader.vue'

export default {
  name: 'ProductionTrendsSkeleton',
  components: { SkeletonLoader },
  data () {
    return {
      timeframePills: [
        { id: 1, width: '55px' },
        { id: 2, width: '45px' },
        { id: 3, width: '50px' },
        { id: 4, width: '60px' },
        { id: 5, width: '50px' }
      ],
      headerColumns: [
        { id: 1, width: '90px' },
        { id: 2, width: '70px' },
        { id: 3, width: '80px' },
        { id: 4, width: '65px' },
        { id: 5, width: '75px' }
      ],
      tableRows: [
        { id: 1, nameWidth: '110px', values: ['50px', '65px', '45px', '70px'] },
        { id: 2, nameWidth: '130px', values: ['60px', '40px', '55px', '50px'] },
        { id: 3, nameWidth: '95px', values: ['45px', '70px', '60px', '40px'] },
        { id: 4, nameWidth: '120px', values: ['55px', '50px', '40px', '65px'] },
        { id: 5, nameWidth: '105px', values: ['65px', '45px', '70px', '55px'] },
        { id: 6, nameWidth: '140px', values: ['40px', '60px', '50px', '45px'] }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.prod-trends-skeleton {
  padding: 16px 20px;
}

/* Filter Row */
.sk-filter-row {
  display: flex;
  align-items: flex-end;
  gap: 16px;
  margin-bottom: 16px;
}

.sk-filter-col {
  .sk-line {
    margin-bottom: 6px;
  }
}

/* Timeframe Pills */
.sk-pills-row {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;

  .sk-rect {
    border-radius: 16px;
  }
}

/* Chart Area */
.sk-chart-area {
  margin-bottom: 24px;

  .sk-rect {
    border-radius: 8px;
  }
}

/* Table */
.sk-table-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.sk-table-header {
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}

.sk-table-row {
  border-bottom: 1px solid #f1f5f9;

  &:last-child {
    border-bottom: none;
  }
}

.sk-col {
  flex: 1;
  min-width: 0;

  .sk-line {
    margin-bottom: 0;
  }
}

.sk-col--name {
  flex: 2;
  display: flex;
  align-items: center;
  gap: 10px;

  .sk-line {
    margin-bottom: 0;
  }
}

/* Responsive: Tablet */
@media (max-width: 991px) {
  .sk-filter-row {
    flex-wrap: wrap;
  }

  .sk-filter-col {
    flex: 1 1 calc(50% - 8px);
  }
}

/* Responsive: Mobile */
@media (max-width: 575px) {
  .sk-filter-row {
    flex-direction: column;
    align-items: stretch;
  }

  .sk-filter-col {
    width: 100% !important;
  }

  .sk-pills-row {
    flex-wrap: wrap;
  }

  .hide-mobile {
    display: none;
  }

  .sk-col--name {
    flex: 1;
  }
}
</style>
